import React, { useEffect, useRef, useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import amplitude from 'amplitude-js';
import { updateFormProperties } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import PreCheckRow from 'apps/auth/components/common/send/popups/Precheck/PreCheckRow';
import { Text } from 'apps/auth/components/common/Text/Text';
import { REQUESTS_CONFIRM_CLICKED, REQUESTS_CONFIRM_SHOWN } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { PAYOUT_COUNTRY } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { FEE_TEXT_POPUP } from 'apps/auth/constants/ComponentNames';
import { DELIVERY_LIBRE_PAYSEND_LIVE } from 'apps/auth/constants/Constants';
import { BILL_ISSUER_COMMENT } from 'apps/auth/constants/fieldsName';
import { REQUEST_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_REQUEST_SEND_ACTION } from 'apps/auth/constants/UrlConstants';
import { USA } from 'apps/auth/constants/WellKnownCountries';
import { resolveArguments, toLowerCase } from 'apps/auth/helpers/utils';
import { useAuth, useExtra, useFields, usePageMessages } from 'apps/auth/hooks/selectors';
import { useCountryMobileMask } from 'apps/auth/hooks/useCountryMobileMask';

import InputText from '../form-multi/InputText';

const HiddenSpan = styled.span`
    opacity: 0;
    position: absolute;
`;

const PrecheckPopup = ({ popupRef = null, ...props }) => {
    const { usaNotRecipt, prechequeBlockTo, confirmFooterNotionBlock, termsOfUseCode, precheckAgreeButton, deliveryOptionBlock, requestToPaysend } =
        usePageMessages();
    const { fromCountry, precheck, commission } = useExtra();
    const { countryId: userCountry } = useAuth();
    const fields = useFields(REQUEST_FORM_NAME);

    const [width, setWidth] = useState(0);
    const hiddenSpan = useRef();
    const { defaultMask, masks, isReady, isMaskReadyForIso2 } = useCountryMobileMask(fromCountry?.code);

    useEffect(() => {
        setWidth(hiddenSpan.current.offsetWidth + 36);
    }, []);

    useEffect(() => {
        amplitude.getInstance().logEvent(REQUESTS_CONFIRM_SHOWN, { [PAYOUT_COUNTRY]: fromCountry?.nameEn });
    }, []);

    const payAgree = (e) => {
        e.preventDefault();
        amplitude.getInstance().logEvent(REQUESTS_CONFIRM_CLICKED);
        if (props.submitRef && props.submitRef.current) {
            props.updateFormProperties(props.formName, AUTH_REQUEST_SEND_ACTION).then(() => {
                props.submitRef.current.click();
                popupRef?.current?.close();
            });
        }
    };

    const getAvatar = () => {
        if (precheck.avatar) {
            return precheck.avatar;
        } else {
            return null;
        }
    };

    const getLetter = () => {
        if (precheck.avatar) {
            return null;
        } else if (precheck.firstLetter) {
            return precheck.firstLetter;
        } else {
            return ':)';
        }
    };

    return (
        <ComplexPopup
            popupRef={popupRef}
            handleClose={props.handleClose}
            precheckPopupButtons={<Button type="button" caption={precheckAgreeButton} onClick={payAgree} raised={true} />}
        >
            <Row textAlign="center">
                {userCountry === USA && (
                    <Text variant="div" size="secondary" indent="adaptive-24-32">
                        {usaNotRecipt}
                    </Text>
                )}
                <Row indent="adaptive-16-24">
                    <DiskBadge src={getAvatar()} diskText={getLetter()} diskSize="large" flagName={fromCountry?.code} />
                </Row>
                <Row flex justify="center" align="center" type="span" indent="4px">
                    <Text variant="span">{prechequeBlockTo}</Text>
                    <Text variant="span" leftSpacer>
                        <HiddenSpan ref={hiddenSpan}>{precheck.accountFrom}</HiddenSpan>
                        {isReady && isMaskReadyForIso2 && (
                            <PhoneInput
                                specialLabel={''}
                                value={precheck.accountFrom}
                                defaultMask={defaultMask}
                                masks={masks}
                                disableDropdown={true}
                                inputProps={{ readOnly: true }}
                                inputStyle={{
                                    fontSize: 'inherit',
                                    lineHeight: 'inherit',
                                    fontFamily: 'inherit',
                                    border: 'none',
                                    background: 'inherit',
                                    color: 'inherit',
                                    width: width,
                                }}
                            />
                        )}
                    </Text>
                </Row>
                <Row indent="adaptive-32-48">
                    <Text size="header">
                        {`${precheck.formatedAmountTo} `}
                        <Text size="header" smallCaps>
                            {toLowerCase(commission.restrictionTo?.ccyIso)}
                        </Text>
                    </Text>
                </Row>
                <Row indent="adaptive-24-32">
                    <InputText formName={REQUEST_FORM_NAME} field={fields[BILL_ISSUER_COMMENT]} isNewInput isCenteredInput />
                </Row>
                {userCountry === USA && (
                    <Text variant="div" size="secondary" indent="adaptive-24-32">
                        {confirmFooterNotionBlock}
                    </Text>
                )}
                <Text variant="div" size="secondary" indent="adaptive-24-32">
                    {resolveArguments(termsOfUseCode, precheck.termsOfUseParams ? precheck.termsOfUseParams.split(';') : null)}
                </Text>
                {precheck.deliveryMethod === DELIVERY_LIBRE_PAYSEND_LIVE && (
                    <TableContainer>
                        <PreCheckRow
                            title={deliveryOptionBlock}
                            text={
                                <>
                                    {requestToPaysend}
                                    <DiskButton type="button" iconName="info-rounded" size="small" marginRight="-8px" marginTop="-4px" raised={false} />
                                </>
                            }
                            onClick={() => {
                                props.setPopup(FEE_TEXT_POPUP);
                                popupRef?.current?.open();
                            }}
                        />
                    </TableContainer>
                )}
            </Row>
        </ComplexPopup>
    );
};

PrecheckPopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(null, { updateFormProperties })(PrecheckPopup);
